<script lang="ts" setup>
import { computed, onBeforeMount } from 'vue'
import { ModalsContainer } from 'vue-final-modal'
import { useRoute } from 'vue-router'
import { get } from 'lodash'
import { useFavicon } from '@vueuse/core'
import Auth from '@helm/layouts/Auth.vue'
import Helm from '@helm/layouts/Helm.vue'
import utils from '@/plugins/utils'
import Blank from '@/layouts/Blank.vue'

onBeforeMount(() => {
    utils()
})

const route = useRoute()

const icon = useFavicon()
icon.value = `/helm/favicon.png`

const layout = computed(() => {
    switch (get(route, `meta.layout`)) {
        case `auth`:
            return Auth
        case `blank`:
            return Blank
    }
    return Helm
})
</script>

<template>
    <component :is="layout">
        <RouterView />
    </component>

    <ModalsContainer />
</template>
